import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { HttpClient } from "@angular/common/http";
import { MstGroupSkillLinkContainerModel } from "../../../../../../models/aggregates/alg/bot";
@Injectable({ providedIn:"root" })
export class MstGroupSkillLinkService extends BaseApiTemplateService<MstGroupSkillLinkContainerModel> {
  constructor(http: HttpClient) 
  {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE +  "mst-group-skill-links/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + "mst-group-skill-links/backoffice-ep";
    this.httpClient = http;
}


}